import { useProfileData } from "~/composables/useProfile";

const badgeFeatureEnabled: boolean = false;

export function useBadgeCount() {
  const { data } = useProfileData();
  return computed(() =>
    badgeFeatureEnabled
      ? (data.value?.participationsToValidateCount ?? 0) + (data.value?.participationsInvitationsCount ?? 0)
      : 0
  );
}
